
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.374 12.332l-1.984-.153s-.05 0-.05-.05v-.052l.152-.56s0-.05.05-.05l1.68-.356-.102-2.34s-.407-1.068-.407-1.374c0-.203-.051-.406-.051-.508l-.56-.051L.71 6.533H.202c-.051 0-.051-.051-.051-.051v-.407l.305-.61s0-.204.509-.204c.457 0 5.188-.05 5.188-.05l.509-.204c.05-.865.152-1.933.356-1.933h.203l.051-.102H5.797c-.05 0-.05 0-.05-.051s0-.05.05-.05c0 0 .458-.103 1.017-.103h.51c.05-.05.1-.101.152-.101.05 0 .101.05.152.101h.509c.56 0 1.017.102 1.017.102.051 0 .051.051.051.051 0 .05-.05.05-.05.05H7.678l.051.103h.204c.254 0 .356 1.068.356 1.933l.56.203c.304 0 4.73.051 5.188.051.508 0 .508.203.508.203l.306.56v.407c0 .05-.051.05-.051.05h-.509L8.9 6.788l-.56.05c0 .103-.05.306-.05.51 0 .305-.407 1.322-.407 1.373l-.102 2.29 1.679.355s.05 0 .05.051l.153.56v.05s-.05 0-.05.051l-1.985.153h-.254v.102z"}})])
          )
        }
      }
    